import { render, staticRenderFns } from "./InvestQuantityBase.vue?vue&type=template&id=1b2ca328&scoped=true"
import script from "./InvestQuantityBase.vue?vue&type=script&lang=js"
export * from "./InvestQuantityBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ca328",
  null
  
)

export default component.exports